// extracted by mini-css-extract-plugin
export var editButton = "detailsGalerie-module--edit-button--dea07";
export var galerieContainer = "detailsGalerie-module--galerie-container--b0dcc";
export var galerieImage = "detailsGalerie-module--galerie-image--27d44";
export var galerieImageContainer = "detailsGalerie-module--galerie-image-container--287a4";
export var galerieTitle = "detailsGalerie-module--galerie-title--0ff63";
export var masonryGrid = "detailsGalerie-module--masonry-grid--78400";
export var masonryGridColumn = "detailsGalerie-module--masonry-grid-column--654df";